import { AHButton, AHText, Box, useTime } from "arkh";
import React from "react";
import { FormattedMessage } from "react-intl";
import { StyleSheet } from "react-native";
import { graphql, useLazyLoadQuery } from "react-relay";
import { Lottie } from "../../../../components/Lottie";

import { useIntlTokens } from "../../../../components/mobile/useIntlTokens";

export function SetupScreen(props: {
  storecastId: string;
  hasOfflineScreens: boolean;
  onAddScreen: () => void;
}) {
  const intl_tokens = useIntlTokens();

  const time = useTime(1000);

  useLazyLoadQuery(
    graphql`
      query SetupScreenPollForTVQuery($id: ID!) {
        dashboard(id: $id) {
          id
          name
          screens {
            id
            name
            activeSession {
              id
            }
          }
          temporaryScreen {
            id
          }
        }
      }
    `,
    {
      id: props.storecastId,
    },
    {
      fetchPolicy: "store-and-network",
      fetchKey: time.toISO(),
    }
  );

  return (
    <Box spaceHorizontal="large" style={{ flex: 1, alignItems: "center" }}>
      <AHText type="list-item-title" color="text-secondary" spaceBottom="small">
        <FormattedMessage
          defaultMessage="Your dashboard doesn’t have a screen to connect to."
          description="Focus BS Setup screen title"
          values={{
            FocusMode: intl_tokens.FocusMode,
          }}
        />
      </AHText>
      {props.hasOfflineScreens && (
        <AHText
          type="list-item-title"
          color="text-secondary"
          spaceBottom="small"
        >
          <FormattedMessage
            defaultMessage="Already installed a screen? Is it turned on with internet connection and on the website storecast.app?"
            description="Focus BS Setup screen title has offline screens"
          />
        </AHText>
      )}
      <Box style={{ flex: 1, width: "100%" }}>
        <Lottie
          source={require("./dashboard.json")}
          autoPlay
          loop
          style={{ ...StyleSheet.absoluteFillObject, width: "100%" }}
        />
      </Box>
      <Box spaceBottom="large" spaceTop="medium" style={{ width: "100%" }}>
        <AHButton
          themeType="primary"
          title={
            <FormattedMessage
              defaultMessage="Setup New Screen"
              description="focus mode bottom sheet button setup new screen"
            />
          }
          onPress={props.onAddScreen}
        />
      </Box>
    </Box>
  );
}
